import React from 'react'
import Icon from 'components/Icon'
import Memory from 'components/Memory'
import { clientId } from 'utils'
import messages from './messages'
import { FormattedMessage, useIntl } from 'react-intl'
import { Button } from '@arnsbogroup/react-voicearchive'

const Memories = ({ attribute, state: initialState, onChange }) => {
  const { key, name, options, disabled, value } = attribute
  const state = initialState || []

  return (
    <fieldset className="space-y-3">
      <div className="flex justify-between items-center">
        <p className="text-xs font-medium text-gray-600 uppercase tracking-wider">
          { name }
        </p>

        { !disabled &&
          <Button
            variant="inline"
            size="sm"
            onClick={() => onChange([ ...state, { id: clientId(), src: null, text: '', } ])}
            icon={['fa', 'plus']}
            iconPosition="right"
          >
            <FormattedMessage {...messages.pronunciation}/>
          </Button>
        }
      </div>

      <div className="space-y-2">
        { state && state.map(({ id, src, text }, i) => (
          <Memory
            key={id}
            id={id}
            src={src}
            text={text}
            onDelete={() => {
              if (disabled) {
                return
              }

              onChange(state.filter((_, index) => i !== index))
            }}
            onChange={({ src, text }) => {
              if (disabled) {
                return
              }

              onChange(Object.assign([], state, {
                [i]: { ...state[i], src: src || state[i].src, text: text || state[i].text }
              }))
            }}
          />
        )) }
      </div>

    </fieldset>
  )
}

export default Memories
